import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-document-search',
  templateUrl: './document-search.component.html',
  styleUrls: ['./document-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentSearchComponent {
  @Input() placeholder: string = 'global.texts.search_plc';
  @Input() value: string = '';
  @Input() showFilterChips: boolean = false;
  @Input() colors: { title_color?: string; text_content_color?: string };

  @Output() searchChange = new EventEmitter<string>();
  @Output() clear = new EventEmitter<void>();

  readonly filterChips: { label: string; type: string }[] = [
    { label: 'Word', type: 'word' },
    { label: 'PDF', type: 'pdf' },
    { label: 'Excel', type: 'excel' },
    { label: 'Imagens', type: 'image' },
  ];

  activeChip: string | null = null;

  onInput(event: any): void {
    const query = event.target?.value || '';
    this.value = query;
    this.searchChange.emit(query);
  }

  onClear(): void {
    this.value = '';
    this.activeChip = null;
    this.clear.emit();
  }

  toggleChip(type: string): void {
    if (this.activeChip === type) {
      this.activeChip = null;
      this.value = '';
      this.searchChange.emit('');
    } else {
      this.activeChip = type;
      this.value = type;
      this.searchChange.emit(type);
    }
  }
}
